import { useMutation } from '@tanstack/react-query';

import { ordersRecognitionApi } from '@widgets/OrdersRecognition/api';

export const useUpdateItemDate = (itemType: 'purchase' | 'excess' = 'purchase') =>
    useMutation({
        mutationFn:
            itemType === 'purchase'
                ? ordersRecognitionApi.updateItemDate
                : ordersRecognitionApi.updateExcessItemDate,
    });
